import React from "react";

import { getCurrencySymbol } from "../../../utils/currency";

const CoinsPricingList = (props) => {
  const { coinPackages, preferredCurrency, productType } = props;
  const currencyUnit = getCurrencySymbol(preferredCurrency);

  return (
    <>
      {productType !== "card" && (
        <>
          <h4 className="pt-2 heading-xxsmall">What is a Coin?</h4>
          <p>
            Our online invites are sent with credits called Coins. Each Premium
            element costs 1-2 Coins per invite. You may add or remove Premium
            options. If you have any questions, please{" "}
            <a
              className="text-gatsby"
              href="mailto:help@paperlesspost.com"
              target="_top"
            >
              contact us
            </a>
            .
          </p>
        </>
      )}
      <ul
        className='relative my-6 ml-6 pl-6 list-none before:content-[""] before:absolute before:top-0 before:left-0 before:h-full before:w-2 before:bg-panna-cotta'
      >
        {coinPackages.map(({ id, coins, prices }) => {
          const currencyPrice = (prices[preferredCurrency] / 100).toFixed(2);
          const perCoinPrice = (currencyPrice / coins).toFixed(2);

          return (
            <li key={id}>
              {coins} Coins for {currencyUnit}
              {currencyPrice}{" "}
              <span className="text-dusty-gray">
                ({currencyUnit}
                {perCoinPrice} each)
              </span>
            </li>
          );
        })}
      </ul>
      <p>Unused Coins may be used for future events.</p>
    </>
  );
};

export default CoinsPricingList;
